import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Globalclasses from "../../App.module.css";
import { useTranslation } from 'react-i18next';
import "../../assets/css/customstyles.css";
import { apiServices } from '../../services/apiServices';
import OfflineDb from '../../db'
import {useGlobalSpinnerActionsContext} from '../../context/GlobalSpinnerContext'
import swal from 'sweetalert'
import { useHistory } from "react-router-dom";
import '../../assets/css/customstyles.css'
import '../../assets/css/theme_grey.css'
import '../../assets/css/theme_blue.css'
import '../../assets/css/theme_green.css'
import '../../assets/css/theme_red.css'
import moment from 'moment';
import {
    SingleSelectFieldFF,
    SingleSelectOption,
    ReactFinalForm,
    InputFieldFF
} from '@dhis2/ui';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker } from "mui-rff";
import { $CombinedState } from "redux";
const { Form, Field, FormSpy } = ReactFinalForm
const Targets = () => {
    const { t } = useTranslation();
    const [orwUsers,setOrwUsers] = useState([])
    const [years,setYears] = useState([{'value':"2021", 'label': "2021" },{'value':"2022", 'label': "2022" }])
    const [months,setMonths] = useState([{ 'value':"1", 'label': t("January") },{ 'value':"2", 'label': t("February") },{ 'value':"3", 'label':  t("March") },{ 'value':"4", 'label':  t("April") },{ 'value':"5", 'label':  t("May") },{ 'value':"6", 'label':  t("June") },{ 'value':"7", 'label':  t("July") },{ 'value':"8", 'label':  t("August") },{ 'value':"9", 'label':  t("September") },{ 'value':"10", 'label':  t("October") },{ 'value':"11", 'label':  t("November") },{ 'value':"12", 'label':  t("December") }])
    const setGlobalSpinner = useGlobalSpinnerActionsContext()
    const [sessionUserBoValue, setSessionUserBoValue] = React.useState(null)
    const history = useHistory();
    async function getMetaData() {
        /*let metadata = await OfflineDb.getDataFromPouchDB('metaData')
        setProgarmData(metadata.data)*/

        let loginDetails = await OfflineDb.getDataFromPouchDB('loginDetails')
        setSessionUserBoValue(loginDetails.data)
    }
    useEffect(() => {
        getMetaData()
        addYear()
    }, [])

    useEffect(() => {
        setMonths([{ 'value':"1", 'label': t("January") },{ 'value':"2", 'label': t("February") },{ 'value':"3", 'label':  t("March") },{ 'value':"4", 'label':  t("April") },{ 'value':"5", 'label':  t("May") },{ 'value':"6", 'label':  t("June") },{ 'value':"7", 'label':  t("July") },{ 'value':"8", 'label':  t("August") },{ 'value':"9", 'label':  t("September") },{ 'value':"10", 'label':  t("October") },{ 'value':"11", 'label':  t("November") },{ 'value':"12", 'label':  t("December") }])
    }, [localStorage.getItem('locale')])

    
    function addYear() {
        let currentYear = moment().year()
        if(currentYear != "2021" && currentYear != "2022"){
            currentYear = currentYear.toString()
            years.push({'value':currentYear, 'label': currentYear })
            setYears(years)
        }
        //console.log("years",currentYear,years);
    }

    const haldleSubmitAction = (values) => {
        console.log();
    }
    const haldleTargetSubmitAction = (values) => {
    }
    const [noOfWeeks,setNoOfWeeks] = useState('5')
    const [targetSubmitType,setTargetSubmitType] = useState('add')
    const [yearVal,setYear] = React.useState(null)
    const [monthVal,setMonthVal] = React.useState(null)
    const [orwVal,setOrwVal] = React.useState(null)
    const [targetUpdateID,setTargetUpdateID] = useState(null)
    
    useEffect(()=>{
        //console.log("weekValue",weekValue)
        if(yearVal != null && monthVal != null && orwVal != null){
            document.getElementById("target-reached-table").style.visibility = "hidden";
            /*let data = {
                "years":yearVal,
                "month":monthVal,
                "orw":orwVal
            }
            getTargets(data)*/
        }
        
    },[yearVal,monthVal,orwVal])

    useEffect(() => {
        //setYears = [{'value':2020, 'label': "2020" },{'value':2021, 'label': "2021" },{'value':2022, 'label': "2022" }] 
        //setMonths = [{ 'value':1, 'label': "January" },{ 'value':2, 'label': "February" },{ 'value':3, 'label': "March" },{ 'value':4, 'label': "April" },{ 'value':5, 'label': "May" },{ 'value':6, 'label': "February" },{ 'value':7, 'label': "July" },{ 'value':8, 'label': "August" },{ 'value':9, 'label': "September" },{ 'value':10, 'label': "October" },{ 'value':11, 'label': "November" },{ 'value':12, 'label': "December" }]
        //https://eosavemyn.imonitorplus.com/service/api/userGroups?filter=name:eq:SupervisorUser&fields=id,displayName,users[id,name] - use this api for getting the ORWs associated with Supervisor login
        if(sessionUserBoValue != null){
            let supervisorName = sessionUserBoValue ? sessionUserBoValue ? sessionUserBoValue.userCredentials ? sessionUserBoValue.username : null : null : null;
            console.log('sessionUserBoValue',sessionUserBoValue,sessionUserBoValue.userCredentials)
            const getURL = 'userGroups?filter=name:eq:'+supervisorName+'&fields=id,displayName,users[id,name]'
            setGlobalSpinner(true)
            apiServices.getAPI(getURL)
                .then(res => {
                    console.log("res",res);
                    if(res && res.data && res.data.userGroups && res.data.userGroups.length > 0){
                        let orwusers = []
                        res.data.userGroups[0].users.map(user => {
                            var obj = { 'value': user.id, 'label': user.name }
                            orwusers.push(obj)
                        })
                        setOrwUsers(orwusers)
                    }
                    setGlobalSpinner(false)
                }).catch(err => {
                    swal({
                        title: t("Error"),
                        text: t("Sorry, something went wrong"),
                        icon: "error",
                        buttons: t('Close')
                    })
                    setGlobalSpinner(false)
                })
            }
    },[sessionUserBoValue])

    const getTargets = (data) => {
        console.log("data",data);
        let supervisorid = sessionUserBoValue ? sessionUserBoValue ? sessionUserBoValue.userCredentials ? sessionUserBoValue.userCredentials.id : null : null : null;
        let selectedYear = data["years"] ? moment(data["years"]).format('YYYY-MM-DD') : '';
        let selectedMonth = data["month"] ? moment(data["month"]).format('YYYY-MM-DD'): '';
        let selectedORW = data["orw"];
        setYear(selectedYear)
        setMonthVal(selectedMonth)
        setOrwVal(selectedORW)
        console.log("sessionUserBoValue",sessionUserBoValue);
        if (selectedYear > selectedMonth){
            swal({
                title: t("Error"),
                text: t("Date from should be greater than Date to"),
                icon: "error",
                buttons: t('Close')
            })
            return
        }
        if(selectedYear && selectedMonth && selectedORW){
            setGlobalSpinner(true)
            let param = {
                "supervisorid": supervisorid,
                "startdate":selectedYear,
                "enddate":selectedMonth,
                "orwid":selectedORW
            }
            apiServices.postAPI('save/dashboard/getfields', param)
                .then(res => {
                    setGlobalSpinner(false)
                    console.log("res",res);
                    document.getElementById("target-reached-table").style.visibility = "visible";
                    //document.getElementById("week1-reached").value = "0";
                    /*document.getElementById("r5").style.display = "block";
                    document.getElementById("r6").style.display = "block";
                    document.getElementById("t5").style.display = "block";
                    document.getElementById("t6").style.display = "block";
                    /*if(data["years"] && data["month"]){
                        let weeks = getWeeks(data["years"],data["month"],1);
                        setNoOfWeeks(weeks)   
                    }
                    console.log("weeks",noOfWeeks, noOfWeeks == 5, noOfWeeks == "5");*/
                    /*if(noOfWeeks == 4){
                        document.getElementById("r5").style.display = "none";
                        document.getElementById("r6").style.display = "none";
                        document.getElementById("t5").style.display = "none";
                        document.getElementById("t6").style.display = "none";
                    }else if (noOfWeeks == 5){
                        document.getElementById("r6").style.display = "none";
                        document.getElementById("t6").style.display = "none";
                    }*/
                    if(res && res.data && res.data.data && res.data.data.length > 0){
                        //update API
                        setTargetSubmitType('update');
                        setTargetUpdateID(res.data.data[0]["id"]);
                        /*document.getElementById("week1-reached").value = res.data.data[0]["reached_week1"];
                        document.getElementById("week2-reached").value = res.data.data[0]["reached_week2"];
                        document.getElementById("week3-reached").value = res.data.data[0]["reached_week3"];
                        document.getElementById("week4-reached").value = res.data.data[0]["reached_week4"];
                        document.getElementById("week5-reached").value = res.data.data[0]["reached_week5"];
                        document.getElementById("week1-target").value = res.data.data[0]["tested_week1"];
                        document.getElementById("week2-target").value = res.data.data[0]["tested_week2"];
                        document.getElementById("week3-target").value = res.data.data[0]["tested_week3"];
                        document.getElementById("week4-target").value = res.data.data[0]["tested_week4"];
                        document.getElementById("week5-target").value = res.data.data[0]["tested_week5"];
                        data["week1-reached"] = res.data.data[0]["reached_week1"];
                        data["week2-reached"] = res.data.data[0]["reached_week2"];
                        data["week3-reached"] = res.data.data[0]["reached_week3"];
                        data["week4-reached"] = res.data.data[0]["reached_week4"];
                        data["week5-reached"] = res.data.data[0]["reached_week5"];
                        data["week1-target"] = res.data.data[0]["tested_week1"];
                        data["week2-target"] = res.data.data[0]["tested_week2"];
                        data["week3-target"] = res.data.data[0]["tested_week3"];
                        data["week4-target"] = res.data.data[0]["tested_week4"];
                        data["week5-target"] = res.data.data[0]["tested_week5"];*/
                        document.getElementById("reached").value = res.data.data[0]["reached"]
                        document.getElementById("tested").value = res.data.data[0]["tested"]
                        document.getElementById("contact").value = res.data.data[0]["contact"]
                        data["reached"] = res.data.data[0]["reached"]
                        data["tested"] = res.data.data[0]["tested"]
                        data["contact"] = res.data.data[0]["contact"]
                        //console.log("data23",data)
                    }else{
                        //add APIadd
                        setTargetSubmitType('add');
                        /*let reachedWeeks = [];
                        let testedWeeks = []
                        for(let i=1;i<=noOfWeeks;i++){
                            reachedWeeks.push("week"+i+"-reached")
                            testedWeeks.push("week"+i+"-target")
                        }
                        reachedWeeks.map(week=>{
                            document.getElementById(week).value = "0";
                            data[week] = "0";
                        })
                        testedWeeks.map(week=>{
                            document.getElementById(week).value = "0";
                            data[week] = "0";
                        })*/
                        document.getElementById("reached").value = "0";
                        data["reached"] = "0";
                        document.getElementById("tested").value = "0";
                            data["tested"] = "0";
                        document.getElementById("contact").value = "0";
                            data["contact"] = "0";
                    }
                    
                }).catch(err => {
                    swal({
                        title: t("Error"),
                        text: t("Sorry, something went wrong"),
                        icon: "error",
                        buttons: t('Close')
                    })
                    setGlobalSpinner(false)

                })
        }else{
            swal({
                title: t("Alert"),
                text: t("Please select date, orw user"),
                icon: "warning",
                buttons: t('Close')
            })
        }
    }

    const submitTargets = (data) => {
        console.log("data",data);
        let postUrl = 'save/dashboard/addfields';
        let param = {}
        let supervisorid = sessionUserBoValue ? sessionUserBoValue ? sessionUserBoValue.userCredentials ? sessionUserBoValue.userCredentials.id : null : null : null;
        let selectedYear = yearVal ? moment(yearVal).format('YYYY-MM-DD') : '';//data["years"];
        let selectedMonth = monthVal ? moment(monthVal).format('YYYY-MM-DD') : '';;//data["month"];
        let selectedORW = orwVal;//data["orw"];
        param = {
            //"id":"1",
            "supervisorid": supervisorid,
            "year":'',
            "month":'',
            "startdate": selectedYear,
            "enddate": selectedMonth,
            /*"reached_week1": data["week1-reached"] ? data["week1-reached"] : "0",
            "reached_week2": data["week2-reached"] ? data["week2-reached"] : "0",
            "reached_week3": data["week3-reached"] ? data["week3-reached"] : "0",
            "reached_week4": data["week4-reached"] ? data["week4-reached"] : "0",
            "reached_week5": data["week5-reached"] ? data["week5-reached"] : "0",
            "tested_week1": data["week1-target"] ? data["week1-target"] : "0",
            "tested_week2": data["week2-target"] ? data["week2-target"] : "0",
            "tested_week3": data["week3-target"] ? data["week3-target"] : "0",
            "tested_week4": data["week4-target"] ? data["week4-target"] : "0",
            "tested_week5": data["week5-target"] ?data["week5-target"] : "0",*/
            "reached": data["reached"] ? data["reached"] : "0",
            "tested": data["tested"] ? data["tested"] : "0",
            "contact": data["contact"] ? data["contact"] : "0",
            "orwid":selectedORW
        }
        if(targetSubmitType == 'update'){
            postUrl = 'save/dashboard/updatefields';
            param["id"] = targetUpdateID
        }
        setGlobalSpinner(true)
        apiServices.postAPI(postUrl, param)
                .then(res => {
                    setGlobalSpinner(false)
                    console.log("res",res);
                    if(res && res.data && res.data.status == "success"){
                        swal({
                            title: t("Success"),
                            text: t("Data submitted successfully"),
                            icon: "success",
                            buttons: t('Close')
                        })
                    }else{
                        swal({
                            title: t("Error"),
                            text: t("Sorry, something went wrong"),
                            icon: "error",
                            buttons: t('Close')
                        })
                    }
                    if(targetUpdateID){
                        setTargetUpdateID(null)
                    }
                    history.push('/layout/home')
                    //data = {}
                }).catch(err => {
                    swal({
                        title: t("Error"),
                        text: t("Sorry, something went wrong"),
                        icon: "error",
                        buttons: t('Close')
                    })
                    setGlobalSpinner(false)
                    history.push('/layout/home')
                })
    }
    
    const getWeeks = (year, month_number, startDayOfWeek)  => {
        // month_number is in the range 1..12
    
        // Get the first day of week week day (0: Sunday, 1: Monday, ...)
        var firstDayOfWeek = startDayOfWeek || 0;
    
        var firstOfMonth = new Date(year, month_number - 1, 1);
        var lastOfMonth = new Date(year, month_number, 0);
        var numberOfDaysInMonth = lastOfMonth.getDate();
        var firstWeekDay = (firstOfMonth.getDay() - firstDayOfWeek + 7) % 7;
    
        var used = firstWeekDay + numberOfDaysInMonth;
    
        return Math.ceil(used / 7);
    }
    
    return (
        <div className={Globalclasses.container}>
            <main
        style={{
          display: "flex",
          height: "100%",
          width: "100%",
        }}
      >
        <section
          style={{
            backgroundColor: "#fff",
            flexGrow: 1,
            padding: 0,
          }}
        >
            <Grid container spacing={3} className="mt-60px mb-30px registration-page alerts_page">

              <Form
                onSubmit={(values) => haldleSubmitAction(values)}
                render={({ handleSubmit, form, submitting, pristine, values }) => (
                  <form id="target-search" onSubmit={handleSubmit} style={{width: '100%'}}>
                      {
                        values['years'] && values['years'] != yearVal  ? setYear(values['years']) : ""
                    }
                    {
                            values['month'] && values['month'] != monthVal  ? setMonthVal(values['month']) : ""
                    }
                    {
                            values['orw'] && values['orw'] != orwVal  ? setOrwVal(values['orw']) : ""
                    }
                        <Grid container spacing={3} xs={12} lg={12}>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Field
                                    id="orw"
                                    name="orw"
                                    label={t('Select ORW')}
                                    component={SingleSelectFieldFF}
                                    key="orw"
                                    options={orwUsers != null ? orwUsers : []}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                {/* <Field
                                    id="years"
                                    name="years"
                                    label={t('Select Year')}
                                    component={SingleSelectFieldFF}
                                    key="years"
                                    options={years != null ? years : []}
                                /> */}
                                 <DatePicker
                                  disabled={false}
                                  label={t("Date from")}
                                  id="years"
                                  name="years"
                                  required={true}
                                  //value={""}
                                  dateFunsUtils={DateFnsUtils}
                                  margin="normal"
                                  variant="inline"
                                  format={"yyyy-MM-dd"}
                                  //validate={composeValidators(required(values))}
                                //   disableFuture={true}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4} >
                                {/* <Field
                                    id="month"
                                    name="month"
                                    label={t('Select Month')}
                                    component={SingleSelectFieldFF}
                                    key="month"
                                    options={months != null ? months : []}
                                /> */}
                                <DatePicker
                                  disabled={false}
                                  label={t("Date To")}
                                  id="month"
                                  name="month"
                                  required={true}
                                  dateFunsUtils={DateFnsUtils}
                                  margin="normal"
                                  variant="inline"
                                  format={"yyyy-MM-dd"}
                                  validate={true}
                                //   disableFuture={true}
                                  />
                            </Grid>
                            
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: '10px' }}>
                            <button style={{ float: 'right' }} className="regformsubmitbtn" type="button" onClick={() => getTargets(values)}>
                                {t('Apply')}
                            </button>
                        </Grid>

                        <br />
                        <br />
                        <Grid container spacing={0} xs={12} lg={12} id="target-reached-table" style={{ visibility: 'hidden' }}>
                        <Grid container spacing={0} xs={4} lg={4}>
                                    <Grid item xs={12} sm={12} md={12} >
                                        <p className="alertformheading">{t('Contact Target')}</p>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="r1">
                                        <Field
                                            id="contact"
                                            name="contact"
                                            type={'number'}
                                            label={''}
                                            component={InputFieldFF}
                                            key="contact"
                                            //value="12"
                                            //defaultValue='0'
                                            placeholder="0"
                                        />
                                    </Grid>
                                    
                                </Grid>
                                <Grid container spacing={0} xs={4} lg={4}>
                                    <Grid item xs={12} sm={12} md={12} >
                                        <p className="alertformheading">{t('Reach Target')}</p>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="r1">
                                        <Field
                                            id="reached"
                                            name="reached"
                                            type={'number'}
                                            label={''}
                                            component={InputFieldFF}
                                            key="reached"
                                            //value="12"
                                            //defaultValue='0'
                                            placeholder="0"
                                        />
                                    </Grid>
                                    {/*<Grid item xs={12} sm={12} md={4} lg={4} id="r2">
                                        <Field
                                            id="week2-reached"
                                            name="week2-reached"
                                            type={'number'}
                                            label={t('Week 2')}
                                            component={InputFieldFF}
                                            key="week2-reached"
                                            //value={'0'}
                                            //defaultValue='0'
                                            placeholder="0"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="r3">
                                        <Field
                                            id="week3-reached"
                                            name="week3-reached"
                                            type={'number'}
                                            label={t('Week 3')}
                                            component={InputFieldFF}
                                            key="week3-reached"
                                            //value={'0'}
                                            //defaultValue='0'
                                            placeholder="0"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="r4">
                                        <Field
                                            id="week4-reached"
                                            name="week4-reached"
                                            type={'number'}
                                            label={t('Week 4')}
                                            component={InputFieldFF}
                                            key="week1-reached"
                                            //value={'0'}
                                            //defaultValue='0'
                                            placeholder="0"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="r5">
                                        <Field
                                            id="week5-reached"
                                            name="week5-reached"
                                            type={'number'}
                                            label={t('Week 5')}
                                            component={InputFieldFF}
                                            key="week5-reached"
                                            //value={'0'}
                                            //defaultValue='0'
                                            placeholder="0"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="r6" className="hide">
                                        <Field
                                            id="week6-reached"
                                            name="week6-reached"
                                            type={'number'}
                                            label={t('Week 6')}
                                            component={InputFieldFF}
                                            key="week6-reached"
                                            //value={'0'}
                                            //defaultValue='0'
                                            placeholder="0"
                                        />
                </Grid>*/}
                                </Grid>
                                <Grid container spacing={0} xs={4} lg={4}>
                                    <Grid item xs={12} sm={12} md={12} className="">
                                        <p className="alertformheading">{t('Testing Target')}</p>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="t1">
                                        <Field
                                            id="tested"
                                            name="tested"
                                            type={'number'}
                                            label={''}
                                            component={InputFieldFF}
                                            key="tested"
                                            //value={'0'}
                                            //defaultValue='0'
                                            placeholder="0"
                                        />
                                    </Grid>
                                    {/*<Grid item xs={12} sm={12} md={4} lg={4} id="t2">
                                        <Field
                                            id="week2-target"
                                            name="week2-target"
                                            type={'number'}
                                            label={t('Week 2')}
                                            component={InputFieldFF}
                                            key="week1-target"
                                            //value={'0'}
                                            //defaultValue='0'
                                            placeholder="0"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="t3">
                                        <Field
                                            id="week3-target"
                                            name="week3-target"
                                            type={'number'}
                                            label={t('Week 3')}
                                            component={InputFieldFF}
                                            key="week3-target"
                                            //value={'0'}
                                            //defaultValue='0'
                                            placeholder="0"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="t4">
                                        <Field
                                            id="week4-target"
                                            name="week4-target"
                                            type={'number'}
                                            label={t('Week 4')}
                                            component={InputFieldFF}
                                            key="week4-target"
                                            //value={'0'}
                                            //defaultValue='0'
                                            placeholder="0"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="t5">
                                        <Field
                                            id="week5-target"
                                            name="week5-target"
                                            type={'number'}
                                            label={t('Week 5')}
                                            component={InputFieldFF}
                                            key="week5-target"
                                            //value={'0'}
                                            //defaultValue='0'
                                            placeholder="0"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="t6" className="hide">
                                        <Field
                                            id="week6-target"
                                            name="week6-target"
                                            type={'number'}
                                            label={t('Week 6')}
                                            component={InputFieldFF}
                                            key="week6-target"
                                            //value={'0'}
                                            //defaultValue='0'
                                            placeholder="0"
                                        />
            </Grid>*/}
                                </Grid>
                                
                                <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: '10px' }}>
                                    <button style={{ float: 'right' }} className="regformsubmitbtn" type="button" onClick={() => submitTargets(values)}>
                                        {t('Submit')}
                                    </button>
                                </Grid>
                        </Grid>
                  </form>
                )}
              />

                {/*<Grid id="target-reached-table" container spacing={0} xs={12} lg={12} style={{ display: 'none' }}>
                    <Form
                    onSubmit={(values) => haldleTargetSubmitAction(values)}
                    render={({ handleSubmit, form, submitting, pristine, values }) => (
                        <form id="target-render" onSubmit={handleSubmit} style={{width: '100%'}}>
                            <Grid container spacing={0} xs={12} lg={12}>
                                <Grid container spacing={0} xs={6} lg={6}>
                                    <Grid item xs={12} sm={12} md={12} className="">
                                        <p className="alertformheading">{t('Reached')}</p>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="r1">
                                        <Field
                                            id="week1-reached"
                                            name="week1-reached"
                                            type={'number'}
                                            label={t('Week 1')}
                                            component={InputFieldFF}
                                            key="week1-reached"
                                            value="12"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="r2">
                                        <Field
                                            id="week2-reached"
                                            name="week2-reached"
                                            type={'number'}
                                            label={t('Week 2')}
                                            component={InputFieldFF}
                                            key="week2-reached"
                                            //value={'0'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="r3">
                                        <Field
                                            id="week3-reached"
                                            name="week3-reached"
                                            type={'number'}
                                            label={t('Week 3')}
                                            component={InputFieldFF}
                                            key="week3-reached"
                                            //value={'0'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="r4">
                                        <Field
                                            id="week4-reached"
                                            name="week4-reached"
                                            type={'number'}
                                            label={t('Week 4')}
                                            component={InputFieldFF}
                                            key="week1-reached"
                                            //value={'0'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="r5">
                                        <Field
                                            id="week5-reached"
                                            name="week5-reached"
                                            type={'number'}
                                            label={t('Week 5')}
                                            component={InputFieldFF}
                                            key="week5-reached"
                                            //value={'0'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="r6">
                                        <Field
                                            id="week6-reached"
                                            name="week6-reached"
                                            type={'number'}
                                            label={t('Week 6')}
                                            component={InputFieldFF}
                                            key="week6-reached"
                                            //value={'0'}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={0} xs={6} lg={6}>
                                    <Grid item xs={12} sm={12} md={12} className="">
                                        <p className="alertformheading">{t('Tested')}</p>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="t1">
                                        <Field
                                            id="week1-target"
                                            name="week1-target"
                                            type={'number'}
                                            label={t('Week 1')}
                                            component={InputFieldFF}
                                            key="week1-target"
                                            //value={'0'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="t2">
                                        <Field
                                            id="week2-target"
                                            name="week2-target"
                                            type={'number'}
                                            label={t('Week 2')}
                                            component={InputFieldFF}
                                            key="week1-target"
                                            //value={'0'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="t3">
                                        <Field
                                            id="week3-target"
                                            name="week3-target"
                                            type={'number'}
                                            label={t('Week 3')}
                                            component={InputFieldFF}
                                            key="week3-target"
                                            //value={'0'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="t4">
                                        <Field
                                            id="week4-target"
                                            name="week4-target"
                                            type={'number'}
                                            label={t('Week 4')}
                                            component={InputFieldFF}
                                            key="week4-target"
                                            //value={'0'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="t5">
                                        <Field
                                            id="week5-target"
                                            name="week5-target"
                                            type={'number'}
                                            label={t('Week 5')}
                                            component={InputFieldFF}
                                            key="week5-target"
                                            //value={'0'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} id="t6">
                                        <Field
                                            id="week6-target"
                                            name="week6-target"
                                            type={'number'}
                                            label={t('Week 6')}
                                            component={InputFieldFF}
                                            key="week6-target"
                                            //value={'0'}
                                            defaultValue='10'
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={12} md={3} lg={3} style={{ marginTop: '10px' }}>
                                    <button style={{ float: 'right' }} className="regformsubmitbtn" type="button" onClick={() => submitTargets(values)}>
                                        {t('Submit')}
                                    </button>
                                </Grid>
                            </Grid>
                        </form>
                    )}
                    />
                </Grid>*/}
              </Grid>
            </section>
            </main>
        </div>
    )
}

export default Targets;